import { __extends } from "tslib";
import * as React from 'react';
import { namespacedClassnames } from '../../common/namespace-classes';
import { noop, classNames } from '@wix/answers-lib';
import { DeprecatedLinkButton } from '../../primitives/deprecated-buttons/deprecated-link-button/link-button';
import { Tooltip } from '../../primitives/tooltip/tooltip';
import { TextInput } from '../../new-libby/core/inputs/text-input';
import { Icon } from '../../primitives/icon/icon';
import { Popover } from '../../primitives/popover/popover';
import { icon } from '../../icons/processed/date.svg';
import { DatePicker } from '../date-picker';
import * as moment from 'moment';
export var DateInputKey = 'date-input';
var DateInput = /** @class */ (function (_super) {
    __extends(DateInput, _super);
    function DateInput() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            isOpen: false,
            isFocused: false
        };
        _this.openCalendar = function () { return _this.setState({ isOpen: true }); };
        _this.closeCalender = function () { return _this.setState({ isOpen: false }); };
        _this.onFocus = function () { return _this.setState({ isFocused: true }); };
        _this.onBlur = function () { return _this.setState({ isFocused: false }); };
        _this.formatDate = function (date) { return moment.utc(date).format(_this.props.dateFormat || 'D/M/YYYY'); };
        _this.onChange = function (date) {
            _this.closeCalender();
            _this.props.onChange(date);
        };
        return _this;
    }
    DateInput.prototype.render = function () {
        var _a = this, props = _a.props, state = _a.state;
        var dateString = this.formatDate(props.value);
        var popoverBody = React.createElement(DatePicker, { value: props.value, onChange: this.onChange });
        var focused = state.isFocused;
        var disabled = !!props.disabled;
        var cn = namespacedClassnames(DateInputKey, props.className, { 'dd-open': state.isOpen, focused: focused, disabled: disabled });
        var buttonCn = classNames('calendar-cta', { 'dd-open': state.isOpen });
        var comp = (React.createElement(React.Fragment, null,
            React.createElement(TextInput, { placeholder: '', value: dateString, onFocus: this.onFocus, onBlur: this.onBlur, onChange: noop, disabled: props.disabled }),
            React.createElement(Popover, { isOpen: state.isOpen, onOuterAction: this.closeCalender, body: popoverBody },
                React.createElement(DeprecatedLinkButton, { className: buttonCn, onClick: this.openCalendar, disabled: !!props.disabled },
                    React.createElement(Icon, { icon: icon })))));
        return (React.createElement("div", { className: cn }, !!props.disabled ? React.createElement(Tooltip, { body: props.disabled }, comp) : comp));
    };
    return DateInput;
}(React.PureComponent));
export { DateInput };
//# sourceMappingURL=index.js.map